<ion-content class="form-content" *ngIf="authServ.isLogged || menuItem.profile_is_not_required;">

  <ion-header>
    <ion-toolbar mode="ios" color="primary">
      <ion-button (click)="close()" fill="clear" color="white" class="ion-no-padding">
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-text [color]="'white'" class="ion-text-center">
          <h1>{{menuItem.name | caption}}</h1>
        </ion-text>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">


    <ion-grid>
      <ion-row>
        <ion-col size="12" *ngIf="menuItem.profile_is_not_required">
          <ion-item class="capacity__name">
            <ion-label position="stacked">{{menuItem.capacity_name | caption}}
              <ion-text color="primary">*</ion-text>
            </ion-label>
            <ion-input type="text" [(ngModel)]="capacityName"></ion-input>
          </ion-item>
        </ion-col>


        <ion-col size="12" *ngIf="menuItem.profile_is_not_required && !authServ.isLogged">
          <ion-item class="notlogged__name">
            <ion-label position="stacked">{{'Name' | translate}}
              <ion-text color="primary">*</ion-text>
            </ion-label>
            <ion-input type="text" [(ngModel)]="name"></ion-input>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>

    <app-extra-forms></app-extra-forms>

    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <ion-textarea [placeholder]="'Order Note' | translate" class="ion-no-padding note__input"
            [(ngModel)]="noteInput" rows="5"></ion-textarea>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-grid>
</ion-content>

<ion-footer>
  <div class="date__badge__wrapper">
    <ion-text color="primary" class="date__badge">
      <ion-icon name="calendar-outline"></ion-icon>
      {{isoOrderDate}}
      <ion-icon class="hour__icon" name="time-outline"></ion-icon>
      {{orderTime}}
    </ion-text>
  </div>
  <ion-row class="cart__summary">
    <ion-col size="12" class="summary__item__name">
      <ion-text color="primary">{{menuItem.name | caption}}</ion-text>
    </ion-col>
    <ion-col size="12">
      <ion-list>
        <div style="max-height: 23vh; overflow-y: scroll;">
          <ng-container *ngFor="let item of cartServ.cart">
            <div class="cart__summary__item">
              <ion-label>
                <span class="Montserrat item__product__name">{{item.product.name | caption | translate |
                  slice:0:32}}</span>
                <span *ngIf="(item.product.name | caption | translate)?.length > 32">...</span>
                <span class="Montserrat item__product__name">{{' (x' + item.size.quantity + ')'}}</span>

                <ng-container *ngIf="item.size.size | caption | translate">
                  (<span class="item__product__name" [innerHTML]="item.size.size | caption | translate"></span>)
                </ng-container>

                <ion-text color="dark" class="ion-float-right" style="display: flex">

                  <ng-container *ngIf="item.size.currency_code==='TL';else otherLang">
                    <ion-text style="min-width: 10vw; text-align: end;">
                      <b class="item__price"><small>({{item.amount | customCurrency}}
                          {{item.size.currency_code}})</small></b>
                    </ion-text>
                  </ng-container>
                  <ng-template #otherLang>
                    <ion-text style="min-width: 10vw; text-align: end;">
                      <b class="item__price"><small>({{item.size.currency_code}}{{item.amount |
                          customCurrency}})</small></b>
                    </ion-text>
                  </ng-template>
                </ion-text>
              </ion-label>
            </div>
          </ng-container>
          <div class="cart__summary__item" style="border-top: 2px solid lightgray;"
            *ngIf="cartServ.cart.length > 0 && cartServ.totalAmount < menuItem.free_service_over_amount && cartServ.totalAmount !== 0">
            <ion-label style="font-size: 85%; color: #656565">
              <i>{{'Service Charge' | translate }}</i>
              <ion-text color="primary" class="ion-float-right">
                <!-- Fixed (0) -->
                <ng-container *ngIf="menuItem.service_charge_type === 0; else percentCharge">
                  <ng-container *ngIf="menuItem.service_charge_currency_code ==='TL';else currencyFirst">
                    <b><i>{{menuItem.service_charge | customCurrency}} {{menuItem.service_charge_currency_code}}</i></b>
                  </ng-container>
                  <ng-template #currencyFirst>
                    <ion-text color="primary">
                      <b><i>{{menuItem.service_charge_currency_code}}{{menuItem.service_charge| customCurrency}}</i></b>
                    </ion-text>
                  </ng-template>
                </ng-container>
                <!-- Percentage (1) -->
                <ng-template #percentCharge>
                  <ng-container>
                    <b>
                      <i>
                        %{{menuItem.service_charge}}
                        (
                          {{
                            (cartServ.totalAmount * (menuItem.service_charge / 100)) | customCurrency
                          }}
                          {{menuItem.service_charge_currency_code}}
                        )
                      </i>
                    </b>
                  </ng-container>
                </ng-template>
              </ion-text>
            </ion-label>
          </div>
        </div>

        <div class="cart__summary__item" style="border: none;">
          <ion-label color="dark">{{'Total' | translate }}
            <ion-text color="primary" class="ion-float-right total__amount">
              <ng-container *ngIf="cartServ.currencyCode==='TL';else otherLang">
                <b>
                  {{
                    cartServ.totalAmount +
                    (
                      cartServ.totalAmount < menuItem.free_service_over_amount && cartServ.totalAmount !== 0
                        ? (
                            menuItem.service_charge_type === 0
                              ? menuItem.service_charge
                              : (cartServ.totalAmount * menuItem.service_charge / 100)
                          )
                        : 0
                    )
                    | customCurrency
                  }}
                  {{cartServ.currencyCode}}
                </b>
              </ng-container>
              <ng-template #otherLang>
                <ion-text class="total__amount" color="primary">
                  <b>
                    {{cartServ.currencyCode}}
                    {{
                      cartServ.totalAmount +
                      (
                        cartServ.totalAmount < menuItem.free_service_over_amount && cartServ.totalAmount !== 0
                          ? (
                              menuItem.service_charge_type === 0
                                ? menuItem.service_charge
                                : (cartServ.totalAmount * menuItem.service_charge / 100)
                            )
                          : 0
                      )
                      | customCurrency
                    }}
                  </b>
                </ion-text>
              </ng-template>
            </ion-text>
          </ion-label>
        </div>

        <ion-button (click)="isFormFieldsValid();send()" expand="block" color="primary">{{menuItem.mobile_payment ? 'Pay Now' : 'Order Now'
          | translate}}</ion-button>

      </ion-list>
    </ion-col>
  </ion-row>
</ion-footer>